import { render, staticRenderFns } from "./languagesTabs.vue?vue&type=template&id=304062c7&scoped=true"
import script from "./languagesTabs.vue?vue&type=script&lang=js"
export * from "./languagesTabs.vue?vue&type=script&lang=js"
import style0 from "./languagesTabs.vue?vue&type=style&index=0&id=304062c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304062c7",
  null
  
)

export default component.exports